import { Globe } from "lucide-react";
import { WhiteLabelBrand } from "./getWhiteLabelBrand";

type Props = {
  brand?: { brandWebsite: string; title: string } | WhiteLabelBrand;
};

export const SharedAppBrandWebsite = ({ brand }: Props) => {
  return (
    <a
      href={brand?.brandWebsite || "https://www.numerous.com/"}
      target="_blank"
      rel="noreferrer"
      className="cursor-pointer flex gap-2 items-center transition-colors"
      data-testid="websiteAnchor"
    >
      <Globe size={14} />
      {brand?.title || "Numerous"}
    </a>
  );
};
